













import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { moji2Hankana, moji2HanAlphaNum, hankana2Upper } from "@/types";
@Component
export default class AlphaNumHalfKanaInput extends Vue {
  @Prop() public value!: string;
  @Prop({ required: false }) maxlength!: number;
  @Prop({ required: true }) inputType!: number;
  @Emit()
  private input(value: string): string {
    return value;
  }
  @Emit()
  private onChange() {
    this.$emit("change");
    return;
  }
  private inputValue = "";
  private get Value(): string {
    this.inputValue = this.value;
    return this.inputValue;
  }
  private set Value(value: string) {
    this.inputValue = value;
    this.input(value);
  }
  private onKeyup(event: KeyboardEvent) {
    this.handleEvent(event);
  }
  private onBlur(event: FocusEvent) {
    this.handleEvent(event);
  }
  private onInput(event: InputEvent) {
    this.handleEvent(event);
  }
  private handleEvent(event: Event) {
    // ユーザアクションのイベント以外はスルー
    if (!event.isTrusted) {
      return;
    }
    // 変換中は抜ける
    let composing = false;
    if (event instanceof KeyboardEvent || event instanceof InputEvent) {
      composing = event.isComposing;
    }
    if (composing) {
      return;
    }
    let str = this.availableString(this.inputValue);
    // 濁点、半濁点で文字数がオーバーした場合はカット
    str = str.substr(0, this.maxlength);
    this.Value = str;
  }
  // 入力可能文字列変換
  private availableString(str: string): string {
    const slice = str.match(/.{1}/g);
    // 空の場合null
    if (slice == null) {
      return "";
    }
    let result = "";
    for (let i = 0; i < slice.length; i++) {
      result += this.availableCharactor(slice[i]);
    }
    return result;
  }
  private availableCharactor(str: string): string {
    // 入力可能文字へ変換
    str = moji2HanAlphaNum(str); //英数記号を半角
    str = str.toUpperCase(); //アルファベット大文字
    str = moji2Hankana(str); //かなをカタカナ半角
    str = hankana2Upper(str); //半角カナを大文字
    let isMatch;
    switch (this.inputType) {
      case 1:
        isMatch = str.match(/^[0-9]*$/);
        break;
      case 2: //ｦなし 記号ハイフンのみ
        isMatch = str.match(
          /^[0-9A-Zｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔｲﾕｴﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ-]*$/
        );
        break;
      case 3: //ｦなし スペース記号４種類（ - ( ) . ）
        isMatch = str.match(
          /^[0-9A-Zｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔｲﾕｴﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ()-.\s]*$/
        );
        break;
      default:
        isMatch = str.match(
          /^[0-9A-Zｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔｲﾕｴﾖﾗﾘﾙﾚﾛﾜｦﾝﾞﾟ()-.\s]*$/
        );
        break;
    }
    if (isMatch) {
      return str;
    }
    // どれにも当てはまらない場合は空文字を返却
    return "";
  }
}
